
import * as ipxRuntime$h2I_45809VF_459aPTiVUipFqbxRWC5n9RnXwIwSP5_45vzeg from '/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$h2I_45809VF_459aPTiVUipFqbxRWC5n9RnXwIwSP5_45vzeg, defaults: {} }
}
        